import {
  OfferDetailsBase,
  OfferPayload,
} from "../../../services/redux/types/CartLoyaltyV2Types";
import { MAIN_OFFER_TYPE } from "../../enums";
import { AmountOfferType, OfferType } from "../../types";
import Offer from "../Offer/Offer";
import { IsOfferApplicableArgs } from "../types";

export class AmountOffer extends Offer {
  offerType: MAIN_OFFER_TYPE | string;
  details: OfferDetailsBase;

  constructor(offer: AmountOfferType) {
    super(offer as OfferType);
    this.offerType = offer.offerType;
    this.details = offer.details;
    this.isCartV2 = true;
  }

  applyOffer(): OfferPayload | null {
    return {
      id: this.id,
      offerType: this.offerType,
      offerCategory: this.offerCategory,
      details: this.details,
      uiDetails: this.uiDetails,
    };
  }

  isMultiplierOffer(): boolean {
    return this.offerType === MAIN_OFFER_TYPE.MULTIPLIER;
  }

  isPercentageOffer(): boolean {
    return this.offerType === MAIN_OFFER_TYPE.PERCENTAGE_AMOUNT;
  }

  isOfferApplicableByType({ cart }: IsOfferApplicableArgs): boolean {
    if (this.offerType !== MAIN_OFFER_TYPE.MULTIPLIER) {
      const allCartItemsExcluded =
        cart.items.length > 0 &&
        cart.items.every((item) => item.excludeFromOffers);

      return !allCartItemsExcluded;
    }

    return true;
  }

  // -- TEXT FUNCTIONS SECTION - START --

  getOfferCartText(): JSX.Element {
    return <>{this.uiDetails?.mainText[Offer.lng]}</>;
  }

  // -- TEXT FUNCTIONS SECTION - END --
}
